import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

const initialState = {
    landCode: { label: '+45', value: '45', countryCode: 'DK' },
}

export const customerDetailsSlice = createSlice({
    name: 'customerDetails',
    initialState,
    reducers: {
        setLandCode: (state, action: PayloadAction<LabelLandCode>) => {
            state.landCode = action.payload
        },
    },
})

export const { setLandCode } = customerDetailsSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const getLandCode = (state: RootState): LabelLandCode => state.customerDetails.landCode

export default customerDetailsSlice.reducer
